import React, { FunctionComponent, useState } from "react";
import HelpIcon from "@mui/icons-material/Help";
import AcxButton from "components/UI/AcxButton";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import { Grid, IconButton, Stack, Typography } from "@mui/material";
import theme from "Theme/AppTheme";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { Link } from "react-router-dom";
const PatientJourneyStagesDialog = () => {
    const [showPatientJourneyStagesDialog, setShowPatientJourneyStagesDialog] =
        useState(false);
    return (
        <>
            <IconButton
                id="open-patient-journey-info-dialog"
                color="primary"
                onClick={() => {
                    setShowPatientJourneyStagesDialog(true);
                }}
                size="small"
            >
                <HelpIcon fontSize="small" />
            </IconButton>
            <AcxDialog
                title={"Patient Journey Stages"}
                subTitle="Each stage is defined with clear criteria to ensure transparency in how insights are generated."
                isOpen={showPatientJourneyStagesDialog}
                maxWidth={"md"}
                onClose={() => setShowPatientJourneyStagesDialog(false)}
                dialogContentChildren={<ModalContent />}
                hideCancelButton
            >
                <Grid
                    container
                    flex="row"
                    justifyContent={"end"}
                    gap={theme.spacing(1)}
                >
                    <AcxButton
                        color="white"
                        onClick={() => {
                            setShowPatientJourneyStagesDialog(false);
                        }}
                    >
                        Close
                    </AcxButton>
                    <Link className="pendo-ignore" style={{textDecoration:"none"}} to="https://www.authenticxhelp.com/en/articles/11525405-patient-journey-rubric" target="_blank">
                        <AcxButton
                            color="primary"
                            onClick={() => {
                                setShowPatientJourneyStagesDialog(false);
                            }}
                            size="small"
                        >
                            View Rubric
                            <OpenInNewRoundedIcon
                                sx={{ marginLeft: theme.spacing(1) }}
                                fontSize="small"
                            />
                        </AcxButton>
                    </Link>
                </Grid>
            </AcxDialog>
        </>
    );
}


const ModalContent = () => {
    const Title: FunctionComponent<React.PropsWithChildren> = ({children}) => {
        return <Typography fontWeight={theme.typography.fontWeightSemibold}>{children}</Typography>
    }
    const Description: FunctionComponent<React.PropsWithChildren> = ({
        children,
    }) => {
        return (
            <Typography fontWeight={theme.typography.fontWeightRegular}>
                {children}
            </Typography>
        );
    };
    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Grid>
                <Title>Before Treatment</Title>
                <Description>
                    The customer is seeking enrollment, is newly enrolled, has
                    not yet started treatment but is planning to obtain
                    treatment for a patient.
                </Description>
            </Grid>
            <Grid>
                <Title>On Treatment</Title>
                <Description>
                    The patient is currently on treatment.
                </Description>
            </Grid>
            <Grid>
                <Title>Treatment Disruption</Title>
                <Description>
                    The patient has been taking medication, and, for whatever
                    reason, there is a disruption in the treatment whether that
                    is due to a voluntary or involuntary reason.
                </Description>
            </Grid>
            <Grid>
                <Title>Restarting Treatment</Title>
                <Description>
                    The patient is resuming or working to resume treatment after
                    stopping or disruption of treatment.
                </Description>
            </Grid>
            <Grid>
                <Title>After Treatment</Title>
                <Description>
                    The patient has discontinued treatment.
                </Description>
            </Grid>
            <Grid>
                <Title>No Clear Journey Stage</Title>
                <Description>
                    Customer journey stage could not be determined with the
                    information provided in the interaction. This could range
                    from an HCP seeking general information about the
                    medication, programs or services offered by the client,
                    and/or exploring treatment options, or otherwise lack of
                    context in the call.
                </Description>
            </Grid>
        </Stack>
    );
}

export default PatientJourneyStagesDialog;
